import type { IChatAccessRevokedNotificationData } from "@frontend-shared/types";
import { UserMinus } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IChatAccessRevokedCardProps {
  uuid: string;
  data: IChatAccessRevokedNotificationData;
  createdAt: string;
  isRead: boolean;
}

const ChatAccessRevokedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IChatAccessRevokedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="chat_access_revoked"
      createdAt={createdAt}
      isRead={isRead}
      icon={<UserMinus className="h-5 w-5 text-destructive" />}
      iconBgClassName="bg-destructive/10"
      body={t("type.chat_access_revoked.body", {
        ownerName: data.ownerName,
        chatTitle: data.chatTitle,
      })}
    />
  );
};

export const ChatAccessRevokedCard = memo(ChatAccessRevokedCardComponent);
